/**
 * An extended magazine from a depot that ordered for a war twice this size.
 */

import type { Affix } from '@/sim/items/affixContract';

export const SURPLUS_MAGAZINE = {
  id: 'surplusMagazine',
  slot: 'prefix',
  field: 'magazine',
  direction: 1,
  label: 'Increased magazine size',
  nameWord: 'Surplus',
  ranges: {
    common: { min: 0.08, max: 0.15 },
    uncommon: { min: 0.15, max: 0.25 },
    rare: { min: 0.25, max: 0.35 },
    exotic: { min: 0.35, max: 0.45 },
  },
} as const satisfies Affix;
